(() => {
    const MODULE_NAME = 'explore-more-measurements',
        isOpenedInNewTab = window.history.length === 1,
        sessionStartTime = (history.state && history.state.sessionStartTime) || new Date().toISOString(),
        isReferredFromGoogle = wasReferredFromGoogle();
        
    const init = () => {
        if (isReferredFromGoogle) {
            TRC.Timeout.set(() => {
                pushHistoryStateObj();
            }, 25000);
        } else {
            pushHistoryStateObj();
        }
    };

    function pushHistoryStateObj() {
        if (typeof history.pushState !== 'function' || (history.state && history.state.page)) {
            return;
        }
        TRC.dom.on(window, 'popstate', returnToPrevPage);
        history.pushState({
            page: history.length,
            href: location.href, 
            isOpenedInNewTab, 
            sessionStartTime
        }, null, document.URL);
    }

    function returnToPrevPage() {
        const data = {
            isOpenedInNewTab,
            sessionStartTime,
            isReferredFromGoogle,
            sessionEndTime: new Date().toISOString()
        };
        TRCImpl && TRCImpl.sendAbTestEvent && TRCImpl.sendAbTestEvent(MODULE_NAME, data);
        return history.back();
    }

    function wasReferredFromGoogle() {
        const hostname = getHostname();
        const regex = /^(.+\.|(.+)?\/)?google\./;
        return hostname.match(regex) !== null;
    }

    function getHostname() {
        const referrer = TRCImpl && TRCImpl.getReferrer && TRCImpl.getReferrer();
        let hostname = referrer.indexOf('//') > -1 ? referrer.split('/')[2] : referrer.split('/')[0];
        [hostname] = hostname.split(':');
        [hostname] = hostname.split('?');
        return hostname;
    }

    init();
})();
